var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditorIconFill = function SvgEditorIconFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#09090B",
    d: "M11.842 2.18a4.42 4.42 0 0 1 3.398 1.593 4.422 4.422 0 0 1 4.824 4.825 4.424 4.424 0 0 1 1.051 5.521 4.4 4.4 0 0 1-1.051 1.276 4.42 4.42 0 0 1-1.271 3.544 4.42 4.42 0 0 1-3.542 1.279 4.42 4.42 0 0 1-6.81 0 4.42 4.42 0 0 1-4.664-3.16 4.4 4.4 0 0 1-.158-1.652 4.42 4.42 0 0 1 0-6.821 4.422 4.422 0 0 1 4.823-4.812 4.42 4.42 0 0 1 3.4-1.593M11.84 7.65a.745.745 0 0 0-.745.745v2.855H8.24a.745.745 0 0 0 0 1.49h2.855v2.856a.745.745 0 0 0 1.49 0V12.74h2.855a.745.745 0 0 0 0-1.49h-2.855V8.396a.745.745 0 0 0-.745-.745"
  })));
};
export default SvgEditorIconFill;